import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as config from "../../../../constants/config";
import * as componentTypes from "../../../../constants/componentTypes";
import * as serverActions from "../../../../actions/serverActions";
import * as navigationActions from "../../../../actions/navigationActions";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as tooltipHelper from "../../../../helpers/tooltipHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Input from "../../../global/generic/Input";
import Modal from "../../../global/generic/Modal";
import Server from "../../../../models/utils/Server";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";

class EditServerModal extends Component {
    constructor(props) {
        super(props);

        if (this.props.params !== null) {
            this.state = {
                serverName: this.props.params.name !== null ? this.props.params.name : "",
                serverNote: this.props.params.note !== null ? this.props.params.note : "",
                serverEnabled: this.props.params.enabled !== null ? this.props.params.enabled : ""
            };
        } else {
            this.state = {
                serverName: "",
                serverHost: "",
                serverHostValidation: false,
                serverPort: config.SERVER_PORT + "",
                serverNote: ""
            };
        }
    }

    handleServerHostChange = (event) => {
        this.setState({
            serverHost: event.target.value,
            serverHostValidation: validationHelper.isHostValid(event.target.value)
        });
    };

    handleEditButtonClick = () => {
        if (this.props.params !== null) {
            this.props.dispatchEditServerAction(
                this.props.params.id,
                this.state.serverName,
                this.state.serverNote,
                this.state.serverEnabled
            );
        } else {
            let newServer = new Server(
                this.state.serverHost,
                Number(this.state.serverPort),
                null,
                this.state.serverName
            );
            newServer.note = this.state.serverNote;
            this.props.dispatchAddServerAction(newServer);
        }
    };

    handleServerNoteChange = (event) => {
        this.setState({
            serverNote: event.target.value
        });
    };

    handleServerNameChange = (event) => {
        this.setState({
            serverName: event.target.value
        });
    };

    handleServerPortChange = (event) => {
        if (
            validationHelper.isIntegerValueValid(event.target.value) &&
            event.target.value <= config.MAX_NUMBER_OF_PORTS
        ) {
            this.setState({serverPort: event.target.value});
        }
    };

    handleServerEnableChange = () => {
        this.setState({
            serverEnabled: !this.state.serverEnabled
        });
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseServerModalAction();
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    getAddBtnTooltipText = () => {
        if (!this.state.serverHostValidation && this.state.serverHost.trim() !== "") {
            return translate("clientServerSettings.wrongFormatIp");
        }

        return translate("clientServerSettings.fillRequiredFields");
    };

    getEditButton = () => {
        if (this.props.params !== null) {
            if (this.state.serverName.trim() === "") {
                return (
                    <Button
                        className="disabled-btn"
                        tooltipText={translate("clientServerSettings.serverNameMissing")}
                        onMouseEnter={tooltipHelper.createTooltip}
                        label={<Translate value="general.confirm" />}
                    />
                );
            }
            return (
                <Button
                    onClick={this.handleEditButtonClick}
                    label={<Translate value="general.confirm" />}
                    svgBefore={imgConfirm}
                />
            );
        } else {
            if (
                !this.state.serverHostValidation ||
                this.state.serverName.trim() === "" ||
                this.state.serverHost.trim() === "" ||
                this.state.serverPort.trim() === ""
            ) {
                return (
                    <Button
                        className="disabled-btn"
                        tooltipText={this.getAddBtnTooltipText()}
                        onMouseEnter={tooltipHelper.createTooltip}
                        label={<Translate value="general.confirm" />}
                        svgBefore={imgConfirm}
                    />
                );
            }
            return (
                <Button
                    onClick={this.handleEditButtonClick}
                    label={<Translate value="general.confirm" />}
                    svgBefore={imgConfirm}
                />
            );
        }
    };

    getNoteRow = () => {
        return (
            <React.Fragment>
                <div className="col-12 flex flex-align-center-vertical padding-bottom-5">
                    <div className="col-4">
                        <Translate value="general.note" />:
                    </div>
                    <div className="col-8">
                        <Input
                            className="primary-input"
                            type="text"
                            value={this.state.serverNote}
                            onChange={this.handleServerNoteChange}
                            onFocus={this.handleInputFocus}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    };

    getAddRows = () => {
        return (
            <React.Fragment>
                <div className="col-12 flex flex-align-center-vertical padding-bottom-5">
                    <div className="col-4">
                        <Translate value="general.ip" />
                        *:
                    </div>
                    <div className="col-8">
                        <Input
                            className="primary-input"
                            type="text"
                            value={this.state.serverHost}
                            onChange={this.handleServerHostChange}
                            onFocus={this.handleInputFocus}
                        />
                    </div>
                </div>
                <div className="col-12 flex flex-align-center-vertical padding-bottom-5">
                    <div className="col-4">
                        <Translate value="clientServerSettings.port" />
                        *:
                    </div>
                    <div className="col-8">
                        <Input
                            className="primary-input"
                            type="text"
                            value={this.state.serverPort}
                            onChange={this.handleServerPortChange}
                            onFocus={this.handleInputFocus}
                        />
                    </div>
                </div>
                {this.getNoteRow()}
            </React.Fragment>
        );
    };

    getEditRows = () => {
        return (
            <React.Fragment>
                {this.getNoteRow()}
                <div className="col-12 flex flex-align-center-vertical padding-bottom-5">
                    <div className="col-4">
                        <Translate value="general.enabled" />:
                    </div>
                    <div className="col-8">
                        <label className="checkbox-style-light">
                            <input
                                type="checkbox"
                                name="show"
                                className="checkbox"
                                checked={this.state.serverEnabled}
                                onChange={this.handleServerEnableChange}
                            />
                            <span className="checkmark" />
                        </label>
                    </div>
                </div>
            </React.Fragment>
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex flex-align-center-vertical padding-bottom-5">
                    <div className="col-4">
                        <Translate value="clientServerSettings.serverName" />
                        *:
                    </div>
                    <div className="col-8">
                        <Input
                            className="primary-input"
                            type="text"
                            value={this.state.serverName}
                            onChange={this.handleServerNameChange}
                            onFocus={this.handleInputFocus}
                        />
                    </div>
                </div>
                {this.props.params !== null ? this.getEditRows() : this.getAddRows()}
            </React.Fragment>,
            "flex-row-gap-10px flex-wrap slim-scroll"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getEditButton()}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(
                    this.props.params !== null ? (
                        <Translate value="clientServerSettings.editServer" />
                    ) : (
                        <Translate value="clientServerSettings.addNewServer" />
                    )
                )}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{
                    minWidth: "40%"
                }}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseServerModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.EDIT_SERVER_MODAL));
        },
        dispatchAddServerAction: (server) => {
            dispatch(serverActions.addServer(server));
        },
        dispatchEditServerAction: (id, name, note, enable) => {
            dispatch(serverActions.editServer(id, name, note, enable));
        }
    };
};

export default EditServerModal = connect(mapStoreToProps, mapDispatchToProps)(EditServerModal);
